var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (Number(_vm.vipType)===1)?_c('div',{staticClass:"ui-vip-icon",class:("ui-vip-icon__" + _vm.iconDecoType + " ui-vip-icon__size-" + _vm.size + " ui-vip-icon__shape-" + _vm.shape)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }